import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import moment from 'moment';
import { ModalService } from '../../core/services/modal.service';

@Component({
	selector: 'app-cancel-plan',
	templateUrl: './cancel-plan.component.html',
	styleUrls: ['./cancel-plan.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})

export class CancelPlanModalComponent {
	@Input() modalId;

	@Input() maskClose;

	@Input() currentSubscription;

	@Input() membershipLevel;

	@Output() cancelPlanEmitter = new EventEmitter();

	public moment = moment;

	constructor(
		private ms: ModalService,
	) { }

	cancelPlan() {
		this.cancelPlanEmitter.emit(true);
		this.ms.close(this.modalId);
	}

	close() {
		this.ms.close(this.modalId);
	}
}
